/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdPullDownRefreshProps } from './type';

export const pullDownRefreshDefaultProps: TdPullDownRefreshProps = {
  disabled: false,
  loadingBarHeight: 50,
  loadingTexts: [],
  maxBarHeight: 80,
  refreshTimeout: 3000,
  defaultValue: false,
};
